import { render, staticRenderFns } from "./singleCarddailishang.vue?vue&type=template&id=a20e3d94&"
import script from "./singleCarddailishang.vue?vue&type=script&lang=js&"
export * from "./singleCarddailishang.vue?vue&type=script&lang=js&"
import style0 from "./singleCarddailishang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports